import "./styles/App.css";

function App() {
  return <div className="App" />;
}

export default App;
